<template>
  <div class="login__container">
    <div class="mds-layout-grid">
      <div class="mds-layout-grid__row">
        <div class="mds-layout-grid__col mds-layout-grid__col--squeeze-3">
          <loading-spinner v-if="step === 'login'"></loading-spinner>
          <p class="error-message" v-if="step === 'error'">{{ errorMessage }}</p>
          <fiduciary-selection v-if="step === 'select-fiduciary'" />
        </div>
      </div>
    </div>
    <notification :show-contact-info-enabled="false" />
    <modal />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

import { goToRoute } from '@/utils';
import Notification from '@/components/atoms/Notification';
import Modal from '@/components/atoms/Modal';
import FiduciarySelection from '@/components/templates/FiduciarySelection';
import LoadingSpinner from '@/components/atoms/LoadingSpinner';
import { requestToValidateUserAuthentication } from '@/services/Login';

export default {
  name: 'login',
  components: {
    LoadingSpinner,
    FiduciarySelection,
    Notification,
    Modal,
  },
  data() {
    return {
      step: 'login',
      errorMessage: '',
      uimLoginUrl: `${process.env.VUE_APP_UIM_URL}${process.env.VUE_APP_UIM_LOGIN_ENDPOINT}?`
        + `source=${process.env.VUE_APP_UIM_SOURCE}&`
        + `targetUrl=${process.env.VUE_APP_UIM_TARGET_URL}`,
      count: 1,
    };
  },
  computed: {
    ...mapState({
      tokenId: (state) => state.user.auth.tokenId,
      fiduciaryId: (state) => state.user.fiduciary.id,
    }),
  },
  watch: {
    tokenId(newValue) {
      if (newValue) {
        this.step = 'select-fiduciary';
      }
    },
    fiduciaryId(newValue) {
      if (newValue) {
        this.step = 'login';
        goToRoute(this.$route, this.$router, '/');
      }
    },
  },
  methods: {
    ...mapActions({
      setAuthTokenId: 'setAuthTokenId',
      clearAuthTokenId: 'clearAuthTokenId',
    }),
    checkIfUserIsAuthenticated() {
      // if count is greater then 3 display error message
      if (this.count > 3) {
        this.step = 'error';
        this.errorMessage = 'Your user has been created, and needs to be refreshed. Please log out and try to log in again.';
        return;
      }
      requestToValidateUserAuthentication()
        // user is logged in
        .then(() => {
          this.step = 'select-fiduciary';
          this.setAuthTokenId();
        })
        // user is not logged in
        .catch((error) => {
          const httpStatus = (error?.response?.status) ? (error?.response.status) : error?.status;
          if (httpStatus === 401) {
            this.clearAuthTokenId();
            this.step = 'error';
            this.errorMessage = 'Access Denied: You are not authorized to use this application.';
          } else if (httpStatus === 403) {
            // incrementing the count
            this.count += 1;
            // waiting for the user to be inserted in FS Connect database
            setTimeout(() => {
              this.checkIfUserIsAuthenticated();
            }, 5000);
          } else if (httpStatus === 409) {
            this.step = 'error';
            this.errorMessage = 'Access denied. Please contact the FS Connect Administrator to request access.';
          } else {
            this.step = 'error';
            this.errorMessage = `Error ${httpStatus}. Please contact the FS Connect Administrator.`;
          }
        });
    },
  },
  created() {
    // to determine if the user is logged in or not
    this.checkIfUserIsAuthenticated();
  },
};
</script>
<style lang="scss">
.login {
  &__container {
    padding-top: $mds-space-inset-4-x;
    width: 100%;
  }
}
.mds-layout-grid__col {
  display: flex;
  justify-content: center;
}
h2 {
  @include mds-level-2-heading();
}
p {
  font-family: $mds-font-family-sans-serif;
}

.error-message {
  font-weight: $mds-font-weight-regular;
  font-size: $mds-font-size-l;
  color: $mds-text-color-error-on-light;
}
</style>
